import MouseMode from "../../settings/MouseMode";
import {PortalDocumentInterface} from "../../../document/PortalDocument";
import {ViewerMode} from "../../ViewerMode";
import PortalContext from "../../../PortalContext";
import Immutable from "../../../../shared/immutable/Immutable";
import {I18nGlobals} from "../../../../shared/translation/i18nInterface";
import {DebugGlobals} from "../../../dialog/components/settings/DebugDialog";
import FormValues from "./model/FormValues";
import {SidebarFunctionGlobals} from "../../../document/components/pdf/SidebarFunctions";

export interface FormLayerGlobals {
	formValues: Immutable<FormValues> | null;
}

export function initFormLayerGlobals(): FormLayerGlobals {
	return {
		formValues: null
	};
}

export interface FormLayerProperties extends I18nGlobals, DebugGlobals, FormLayerGlobals, SidebarFunctionGlobals {
	pageNumber: number;
	currentPage: number;
	zoomValue: number;
	numberOfPages: number;
	context: PortalContext;
	mouseMode: MouseMode;
	viewerMode: ViewerMode;
	portalDocument: Immutable<PortalDocumentInterface>;
}

export interface FormLayerStatus {
}